import React, { useMemo } from "react";
import OfertaCard from "../components/OfertaCard";

const RecentOffersPage = ({ offersData, user, favoriteIds, toggleFavorite, offerLikesMap }) => {
  const sortedOffers = useMemo(() => {
    return [...offersData].sort((a, b) => {
      const dateA = a.data_cadastro || a.id;
      const dateB = b.data_cadastro || b.id;
      return dateB.localeCompare(dateA);
    });
  }, [offersData]);

  return (
    <div className="container" style={{ paddingTop: '100px', paddingBottom: '60px' }}>
      <div style={{ marginBottom: 'var(--spacing-lg)', display: 'flex', alignItems: 'center', gap: '12px' }}>
        <h1 style={{ fontSize: 'var(--font-size-xl)', fontWeight: '700', margin: 0 }}>
          Todas as Novas Ofertas
        </h1>
        <span style={{ 
          background: 'var(--primary-color)', 
          color: 'white', 
          padding: '4px 10px', 
          borderRadius: '20px', 
          fontSize: '14px',
          fontWeight: '600'
        }}>
          {sortedOffers.length} itens
        </span>
      </div>

      <div className="grid grid-cols-1 grid-sm-2 grid-md-3 grid-lg-4 grid-xl-5">
        {sortedOffers.map((oferta) => (
          <OfertaCard
            key={oferta.id}
            oferta={oferta}
            user={user}
            isFavorite={favoriteIds.includes(oferta.id)}
            onFavoriteToggle={toggleFavorite}
            likes={offerLikesMap[oferta.id] || 0}
          />
        ))}
      </div>

      {sortedOffers.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px', color: 'var(--text-secondary)' }}>
          <p>Aguardando novas ofertas carregarem...</p>
        </div>
      )}
    </div>
  );
};

export default RecentOffersPage;
